import React from 'react';
import { useLocation } from 'react-router-dom';
import CardForm from '../components/CardForm';
import Loader from '../components/Loader';
import { fetchAuth } from '../utils/fetchAuth';

const apiUrl = process.env.REACT_APP_API_URL || '';

interface Props {
    loading?: boolean;
}

const ForgotPassword: React.FC<Props> = ({ loading }) => {
    // dentro do seu componente
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const continueTo = searchParams.get('continue');

    if (loading) return <Loader />;

    return (
        <CardForm
            id='forgot-password'
            title="Esqueci minha senha"
            action={`${apiUrl}/login/forgot-password`}
            method="POST"
            fields={[
                { name: 'email', type: 'email', label: 'Email', required: true },
            ]}
            link={{ label: 'Voltar ao login', url: '/login' + (continueTo ? `?continue=${encodeURIComponent(continueTo)}` : '') }}
            submitLabel="Recuperar Senha"
            onSubmit={async (formData, action, method) => {
                const formElement = document.getElementById('form-forgot-password') as HTMLFormElement;

                if (!formElement) throw new Error('Formulário não encontrado');


                // <- comportamento padrão (form encoded + fetch)
                const body = new URLSearchParams();
                for (const key in formData) {
                    const value = formData[key];
                    if (Array.isArray(value)) {
                        value.forEach(v => body.append(key, v));
                    } else {
                        body.append(key, value);
                    }
                }

                const response = await fetchAuth(action, {
                    method,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: method === 'POST' ? body.toString() : undefined,
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Erro ao recuperar senha');
                }

                const responseData = await response.json();

                formElement.querySelectorAll('.mb-3, button')?.forEach((el) => {
                    (el as HTMLElement).style.display = 'none';
                });

                return {
                    message: responseData.message || 'Verifique seu email para redefinir sua senha.',
                    errorCode: 0,
                }
            }}
        />
    );
}

export default ForgotPassword;
